import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Box, CircularProgress, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { AttachFile, ChatBubble, Close, SendOutlined } from '@mui/icons-material';
import moment from 'moment';
import { useAuth } from '../../context/UseContext';
import ChatServices from '../../apis/chat/ChatServices';
import { ErrorToaster } from '../Helpers/toaster/Toaster';
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { usePusher } from '../../hooks/usePusher';

function Chat() {

  const { user } = useAuth();
  const { conversations, messages, setMessages, handleNewMessage } = usePusher();

  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const { register, handleSubmit, reset } = useForm();
  const [loading, setLoading] = useState(false);

  const [chatScreen, setChatScreen] = useState(false);

  const [conversationId, setConversationId] = useState();

  const [uploadedFile, setUploadedFile] = useState();
  const [previewFile, setPreviewFile] = useState();
  const [imgBaseUrl, setImgBaseUrl] = useState();

  // *For Handle Open Chat Screen
  const handleOpenChat = () => {
    try {
      if (user?.token) {
        setChatScreen(true)
      } else {
        ErrorToaster('Kindly login first')
        navigate('/login')
      }
    } catch (error) {
      console.log('handleOpenChat => error:', error)
    }
  }

  // *For Upload
  const handleUpload = (e, type) => {
    if (e.target.value !== "") {
      setUploadedFile(e.target.files[0])
      const imgReader = new FileReader();
      imgReader.onload = (event) => {
        setPreviewFile(event.target.result);
      };
      imgReader.readAsDataURL(e.target.files[0]);
    }
  };

  // *For Reset File
  const resetFile = () => {
    fileInputRef.current.value = null
    setUploadedFile()
    setPreviewFile()
  }

  // *For Get Conversations By Id
  const getConversationMessages = async () => {
    try {
      const { imageBaseUrl, data } = await ChatServices.getConversationMessages(conversationId)
      setImgBaseUrl(imageBaseUrl)
      const newMessages = []
      data?.forEach(e => {
        const obj = {
          conversationId: e?.conversation_id,
          date: e?.created_at,
          message: e?.message,
          attachment: e?.attachment,
          userId: e?.user_id,
          id: e?.id,
          seen: e?.seen ?? 0,
        }
        newMessages.push(obj)
      })
      setMessages(newMessages)
    } catch (error) {
      console.log('🚀 => getConversationMessages => error:', error)
    }
  }

  // *For Send Message
  const createConversation = async (data) => {
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append('message', data.message)
      if (uploadedFile) {
        formData.append('attachment', uploadedFile)
      }

      if (messages.length > 0) {
        const conversationId = messages[0]?.conversationId
        const { messagedata } = await ChatServices.sendMessage(conversationId, formData)
        handleNewMessage(messagedata)
      } else {
        formData.append('receiver', 1) // Id 1 is Admin
        const { messagedata } = await ChatServices.createConversation(formData)
        handleNewMessage(messagedata)
      }
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false);
      reset()
      resetFile()
    }
  }

  useEffect(() => {
    if (chatScreen && conversationId) {
      getConversationMessages()
    }
  }, [chatScreen, conversationId]);

  useEffect(() => {
    if (conversations.length > 0) {
      const adminConversationId = conversations.find(e => e.opposite_user?.id == 1)?.id
      setConversationId(adminConversationId)
    }
  }, [conversations]);

  return (
    <Fragment>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleUpload}
      />

      <Box
        sx={{
          position: 'fixed',
          right: '15px',
          bottom: '25px',
          zIndex: '9999',
        }}
      >
        {chatScreen ? (
          <Box
            sx={{
              width: '350px',
              height: 'calc(100vh - 100px)',
              borderRadius: '6px',
              bgcolor: '#fff',
              boxShadow: '0 4px 20px 0 rgba(0,7,22,.12)'
            }}
          >
            <Box sx={{ bgcolor: '#009640', borderTopLeftRadius: '6px', borderTopRightRadius: '6px', p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" color="white">
                Chat With Us
              </Typography>
              <IconButton
                onClick={() => setChatScreen(false)}
                sx={{
                  color: '#fff',
                }}
              >
                <Close />
              </IconButton>
            </Box>
            <Box sx={{ p: 1, height: 'calc(100vh - 215px)', overflow: 'auto', display: 'flex', flexDirection: 'column-reverse' }}>
              {[...messages].reverse().map((item, index) => (
                <Box key={index} sx={{ maxWidth: '95%', my: 1, width: 'fit-content', ml: user?.id === item?.userId && 'auto', mr: user?.id !== item?.userId && 'auto' }}>
                  <Box sx={{ borderRadius: '4px', bgcolor: '#d9d9d9', p: 1.5 }}>
                    {item?.attachment &&
                      <Box
                        component={'img'}
                        src={imgBaseUrl + item?.attachment}
                        sx={{ maxWidth: '250px', height: 'auto', objectFit: 'contain' }}
                      />
                    }
                    <Typography variant="body2" sx={{ color: '#323B4B' }}>
                      {item.message}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                      <Typography component={'span'} sx={{ fontSize: '10px', color: '#777' }}>
                        {moment(item.date).format('hh:mm A')}
                      </Typography>
                      {user?.id === item?.userId && (
                        item.seen === 1 ? (
                          <svg width="14" height="8" viewBox="0 0 20 11" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.5 5.5L5.5 9.5L13.5 1.5" stroke="#53BDEB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                            <path d="M6.5 5.5L10.5 9.5L18.5 1.5" stroke="#53BDEB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                          </svg>
                        ) : (
                          <svg width="10" height="8" viewBox="0 0 14 11" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.5 5.5L5.5 9.5L13 1.5" stroke="#aaaaaa" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                          </svg>
                        )
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
            <Box component="form" onSubmit={handleSubmit(createConversation)} sx={{ borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', p: 1, borderTop: '1px solid #b6bec9' }}>
              {previewFile &&
                <Box sx={{ position: 'relative' }}>
                  <Box sx={{ position: 'absolute', left: '0px', bottom: '0px', width: '100%', height: 'calc(100vh - 210px)', bgcolor: '#d9d9d9' }}>
                    <IconButton color="primary" onClick={() => resetFile()} sx={{ position: 'absolute', right: 10, top: 10 }}>
                      <Close sx={{ width: '16px', height: '16px', color: '#FF2121' }} />
                    </IconButton>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                      <Box
                        component={'img'}
                        src={previewFile}
                        sx={{ maxWidth: '310px', maxHeight: '310px', objectFit: 'contain' }}
                      />
                    </Box>
                  </Box>
                </Box>
              }
              <TextField
                fullWidth
                size="small"
                placeholder={'Ask a question'}
                {...register("message")}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton component="label" edge="start" onClick={() => fileInputRef.current.click()}>
                        <AttachFile color="primary" />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton type='submit' edge="end" >
                        {loading ? (
                          <CircularProgress size={20} sx={{ color: '#009640' }} />
                        ) : (
                          <SendOutlined sx={{ color: '#009640' }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        ) : (
          <IconButton
            onClick={() => handleOpenChat()}
            sx={{
              p: 2,
              color: '#fff',
              bgcolor: '#009640',
              '&:hover': {
                bgcolor: '#009640',
              }
            }}
          >
            <ChatBubble />
          </IconButton>
        )}
      </Box>
    </Fragment>
  );
}

export default Chat;